export default "__VITE_ASSET__d93fa30e__"